import { useIntlayer } from 'react-intlayer';

import { TacticalDronesFeaturesSection } from './TacticalDronesFeaturesSection';
import { TacticalDronesGallerySection } from './TacticalDronesGallerySection';
import { TacticalDronesOverviewSection } from './TacticalDronesOverviewSection';

import { ProductCTASection } from '~/components/ui/ProductCTASection';
import { ProductHeroSection } from '~/components/ui/ProductHeroSection';

export const TacticalUAVPageContent = () => {
  const {
    cta,
    hero,
    mainPhrase,
    gallery,
    features: featureTiles,
  } =
    useIntlayer('tactical-drones');

  // const products = [
  //   {
  //     number: keyFeatures.feature01.number,
  //     title: keyFeatures.feature01.title,
  //     description: keyFeatures.feature01.description,
  //     image: '/assets/images/10fpv.jpg', // Placeholder - will be updated
  //   },
  //   {
  //     number: keyFeatures.feature02.number,
  //     title: keyFeatures.feature02.title,
  //     description: keyFeatures.feature02.description,
  //     image: '/assets/images/15bomber.jpg', // Placeholder - will be updated
  //   },
  // ];

  return (
    <div className="bg-black min-h-full w-full">
      <ProductHeroSection
        subtitle={hero.subtitle}
        title={hero.title}
        videoSrc="/assets/video/hls/uav_new/master.m3u8" // Placeholder
        fallbackVideoSrc="/assets/video/uav_new.mp4"
        poster="/assets/images/uav_new_frame.jpg"
      />
      <TacticalDronesOverviewSection
        title={mainPhrase.title}
        description={mainPhrase.description}
      />
      <TacticalDronesGallerySection
        largeImage="/assets/images/uav_main.jpg"
        rightTopImage="/assets/images/uav2.jpg"
        rightBottomImage="/assets/images/uav3.jpg"
        text={{
          line1: gallery.line1,
          line2: gallery.line2,
        }}
      />
      <TacticalDronesFeaturesSection
        left={{
          code: featureTiles.c01.code,
          label: featureTiles.c01.label,
          title: featureTiles.c01.title,
        }}
        right={{
          code: featureTiles.c02.code,
          label: featureTiles.c02.label,
          title: featureTiles.c02.title,
        }}
      />
      <div className="h-[120px]" />
      {/* <ProductKeyFeaturesSection title={keyFeatures.title} features={products} /> */}
      <ProductCTASection
        title={cta.title}
        heading={hero.title}
        button1Text={cta.button1}
        backgroundImage="/assets/images/uav_main.jpg" // Placeholder
      />
    </div>
  );
};
